<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();
const touchStartX = ref(0);
const touchEndX = ref(0);

const handleTouchStart = (event) => {
  touchStartX.value = event.changedTouches[0].clientX;
};

const handleTouchEnd = (event) => {
  touchEndX.value = event.changedTouches[0].clientX;
  const swipeThreshold = 50;

  if (touchEndX.value - touchStartX.value > swipeThreshold) {
    setTimeout(() => {
      router.push('/secondMikat');
    }, 300);
  }
};
</script>

<template>
  <section class="background" @touchstart="handleTouchStart" @touchend="handleTouchEnd">
  <div class="container">
      <div class="header_block">
        <router-link to="">
          <img src="@/assets/img/icons/prev.svg">
        </router-link>
        <h2 class="title">Микаты</h2>
        <div></div>
      </div>
      <div class="content">
          <div class="box">
            <p class="text box_import">
              <span><img src="../../assets/img/icons/important.svg"></span>
              Каждый паломник, совершающий хадж или умру, обязан при достижении миката войти в состояние ихрама. если же человек миновал микат и намеренно не вошел в состояние ихрама, то он обязан вернуться и войти в ихрам с пропу- щенного места. в противном же случае, на нем лежит обязанность принести в жертву овцу в мекке и там же раздать мясо бедным.
            </p>
          </div>
        <div class="pagination">
          <span>{{ 3 }}/{{ 3 }}</span>
        </div>
        </div>
  </div>
  </section>
</template>

<style lang="scss" scoped>
.content {
  position: relative;
}
.box {
  border: 1px solid #DB0E21;
  border-radius: 15px;
  padding: 15px;
}

.pagination {
  position: absolute;
  bottom: 27px;
  left: 50%;
  transform: translateX(-50%);
  color: #525D68;
  display: flex;
  justify-content: center;
  width: 100%;
}
</style>
